export function isCostRecoveryRequiredUnset(value: unknown): boolean {
  return value === undefined || value === null || value === "";
}
